import { WithUserNamespace } from '../../state/user';
import { isUserLoggedIn } from './directSelectors';

export const getLoggedInUser = (state: WithUserNamespace) =>
    (isUserLoggedIn(state) && state?.user) || null;
